// =============================================================================
// index.tsx — Application entry point
// Project: Texas Hold'em Social Casino
// =============================================================================
// Mounts the React app and initializes the Platform SDK.

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Initialize platform adapter before rendering
async function main(): Promise<void> {
  const root = document.getElementById('root')
  if (!root) {
    document.body.innerHTML = '<p>Failed to initialize application</p>'
    return
  }

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

main().catch(console.error)
